// auto-generated by Typewriter template _models.tst from PortCall.EndPoints\Api\CoordinationMilestoneType\ApiCoordinationMilestoneType.cs
import S, { DataSignal } from 's-js';
import SArray, { SDataArray } from 's-array';
import TZDate from 'lib/TZDate';
import { jsonableObservable } from 'lib/jsonableObservable';
import { Coordination, CoordinationData, CoordinationOptions } from 'data/models/Coordination';
import { MilestoneType, MilestoneTypeData, MilestoneTypeOptions } from 'data/models/MilestoneType';

// CoordinationMilestoneTypeData is the class that CoordinationMilestoneType serializes to/from
export interface CoordinationMilestoneTypeData {
    CoordinationId : number;
    MilestoneTypeId : number;
	
    Coordination : CoordinationData | null;
    MilestoneType : MilestoneTypeData | null;
	
}

// CoordinationMilestoneTypeOptions is the class which may be passed to the CoordinationMilestoneType constructor to define optional initial data values
export interface CoordinationMilestoneTypeOptions {
    CoordinationId : number;
    MilestoneTypeId : number;
	
    Coordination? : CoordinationOptions | null;
    MilestoneType? : MilestoneTypeOptions | null;
	
}

export class CoordinationMilestoneType {
    public CoordinationId : DataSignal<number>;
    public MilestoneTypeId : DataSignal<number>;
	
    public Coordination : DataSignal<Coordination | null>;
    public MilestoneType : DataSignal<MilestoneType | null>;
	

    constructor();
    constructor(data : CoordinationMilestoneTypeOptions);
    constructor(data: CoordinationMilestoneTypeOptions | null = null) {
        this.CoordinationId = jsonableObservable(S.value<number>(data && data.CoordinationId !== undefined ? data.CoordinationId : 0));
        this.MilestoneTypeId = jsonableObservable(S.value<number>(data && data.MilestoneTypeId !== undefined ? data.MilestoneTypeId : 0));
	    
        this.Coordination = S.value<Coordination | null>(null);
        this.MilestoneType = S.value<MilestoneType | null>(null);
	    
    }

    static key(obj : CoordinationMilestoneType) {
        return obj.CoordinationId() + '\u2618' + obj.MilestoneTypeId();
    }
    
    static dataKey(obj : CoordinationMilestoneTypeOptions) {
        return obj.CoordinationId + '\u2618' + obj.MilestoneTypeId;
    }

    static update(obj : CoordinationMilestoneType, data : CoordinationMilestoneTypeOptions) {
        S.freeze(() => {
            if (data.CoordinationId !== undefined) obj.CoordinationId(data.CoordinationId);
            if (data.MilestoneTypeId !== undefined) obj.MilestoneTypeId(data.MilestoneTypeId);
	        
	        
        });
    }
}



// WEBPACK FOOTER //
// ./server/models/CoordinationMilestoneType.ts